"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mobxReact = require("mobx-react");
var _reactIntl = require("react-intl");
var _Toast = require("@react/react-spectrum/Toast");
require("!style-loader!css-loader!./Toast.css");
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _classnames = _interopRequireDefault(require("classnames"));
var _class, _ToastView;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * layout for Toasts
 */
let ToastView = exports.default = (0, _mobxReact.observer)(_class = (_ToastView = class ToastView extends _react.default.Component {
  constructor() {
    super();
    this.appStore = _ServiceRegistry.default.getService("AppStore");
  }
  render() {
    const closable = true;
    return /*#__PURE__*/_react.default.createElement(_Toast.Toast, {
      variant: this.props.variant,
      onClose: this.props.onClose,
      closable: closable,
      className: (0, _classnames.default)(["sdk-Toast-toast", this.appStore.enableModernViewer ? "sdk-Toast-toast-modern-viewer" : ""])
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: this.props.message.id,
      values: this.props.message.values
    }));
  }
}, _ToastView.propTypes = {
  message: _propTypes.default.objectOf(_propTypes.default.any).isRequired,
  variant: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func.isRequired
}, _ToastView)) || _class;